import styled from "styled-components"

const StyledCard = styled.div`
    background-color: white;
    border-radius: 10px;
    border: 3px solid #EEEEEE;
    padding: 5px 20px;
`;
export function Card(props) {
    return (
        <StyledCard {...props}>
            {props.children}
        </StyledCard>
    );
}